export default __webpack_public_path__ + "static/media/user-2-1.0591d6ba.svg";